import styled, { css } from 'styled-components';
import { IStreamCellStyledProps } from './stream-cell.types';

export const StreamCellStyled = styled.div<IStreamCellStyledProps>`
  display: flex;
  gap: 8px;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -6px;
    width: 32px;
    height: 32px;
    padding: 8px;
    border-radius: 12px;
    box-sizing: border-box;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.blue[60]}1A;

    ${({ $isLive }) => !$isLive && css`
      cursor: not-allowed;
      opacity: .4;
    `}
  }

  .stream-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .broadcast-tournament {
    color: ${({ theme }) => theme.colors.gray[50]};
  }
`;

export const StreamIFrameStyled = styled.iframe`
  aspect-ratio: 16 / 9;
  width: 640px;
`;
